<template>
  <div class="records" style="margin-top: -10px">
    <!--  heading block -->
    <GlobalHeader :title="'Refund for ' + lists.list_no" @redirectPage="redirectPage"></GlobalHeader>
    <!-- Validation for records -->

    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
           <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>
          <b-alert
            class="alert-transparent alert-danger"
            :show="error_show && this.errors.any()"
          >
            <button
              type="button"
              @click="error_show = !error_show"
              class="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div
              v-for="item in errors.items"
              :key="item.id"
              v-if="item.scope == 'pymt-return-form'"
            >
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      @submit.prevent="onSubmit('pymt-return-form')"
      id="payment_form"
      data-vv-scope="pymt-return-form"
      @click="roundOff()"
      class="mt-1"
      style="margin-left: 3px; margin-right: 3px"
    >
      <div
        class="sales-bg pt-30p pb-4 mb-2 border-bottom-dot"
        style="background: #f7f7f7"
      >
        <!--  amcservice name -->
        <b-row>
          <b-col xl="10" lg="10" md="10" sm="10" xs="10">
            <form class="form-inline">
              <label class="my-1 mr-5" label-for="name">
                Customer Name
                <span class="text-danger pl-1">*</span>
              </label>
              <b-form-input
                style="width: 629px"
                type="text"
                v-model.trim="field.cus_id"
                size="sm"
                disabled
                name="cus_id"
                data-vv-name="customer"
                v-validate="'required'"
              />
            </form>
          </b-col>
        </b-row>
      </div>
      <b-row style="max-width: 1000px" class="mt-4">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            label="From Account"
            label-for="From Account"
            label-class="required"
            class="mb-3"
          >
            <select
              v-model.trim="field.from_account"
              v-chosen="field.from_account"
              name="From Account"
              data-vv-name="From Account"
              v-validate="'required'"
              class="chosen v-select form-control"
            >
              <template
                v-for="(item, index) in accounts.parent_accounts"
                v-if="item.gl_acc_type_id != 21"
              >
                <optgroup :label="item.gl_acc_type" :key="index">
                  <option
                     v-if="
                      (item.gl_acc_type_id!=6&&item.gl_acc_type_id!=21&& child.is_active == 1) ||
                      field.from_account == child.gl_acc_id ||
                      ((item.gl_acc_type_id == 6 ||
                        item.gl_acc_type_id == 21) &&
                        (child.currency == field.cus_currency ||
                          child.currency == org_currency_id))
                    "
                    v-for="child in accounts.child_accounts[
                      item.gl_acc_type_id
                    ]"
                    :key="child.id"
                    :value="child.gl_acc_id"
                  >
                    {{
                      (item.gl_acc_type_id == 6 || item.gl_acc_type_id == 21) &&
                      child.bank_code
                        ? "[" + child.bank_code + "] "
                        : ""
                    }}{{ child.gl_acc_name }}
                  </option>
                </optgroup>
              </template>
            </select>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Refund Amount'"
            label-class="required"
            label-for="Amount_received"
            class="mb-3"
          >
            <b-input-group
              :prepend="
                getDetails(
                  $AppDetails.currency_details,
                  field.cus_currency,
                  'currency_code'
                )
              "
              class="mb-2 mr-sm-2 mb-sm-0 payment_currency"
            >
              <b-input
                :disabled="field.disabled"
                type="text"
                size="sm"
                name="paid_amount"
                data-vv-name="refund amount"
                v-validate="
                  'required|between:0,' +
                  field.due_amount +
                  '|excluded:' +
                  parseFloat(0).toFixed(2) +
                  '|max_value:' +
                  field.due_amount
                "
                v-model.trim="field.paid_amount"
              />
              <span class="pl-2 mr-0">
                <span
                  class="float-left display-flex mt-2"
                  style="font-size: 12px"
                  v-if="field.is_export == 2"
                >
                  1
                  {{
                    getDetails(
                      $AppDetails.currency_details,
                      field.cus_currency,
                      "currency_code"
                    )
                  }}
                  =
                  <b-form-input
                    disabled
                    @blur="
                      field.unit_currency_value =
                        parseFloat(field.unit_currency_value) <= 0
                          ? 1
                          : field.unit_currency_value
                    "
                    type="text"
                    v-model.trim="field.unit_currency_value"
                    class="ml-2 mr-2"
                    style="width: 100px; height: 22px !important"
                    name="Currency"
                    data-vv-name="currency"
                    v-validate="
                      'required|decimal:5|excluded:' +
                      parseFloat(0).toFixed(2) +
                      '|min_value:0'
                    "
                  />
                  {{
                    getDetails(
                      $AppDetails.currency_details,
                      $AppDetails.organization.org_currency,
                      "currency_code"
                    )
                  }}
                </span>
              </span>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width: 1000px" class="mt-3">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            label="Payment Mode"
            label-for="Payment mode"
            class="mb-3"
          >
            <v-select
              :clearable="false"
              id="payment-method-select"
              data-vv-name="payment mode"
              v-validate="'required'"
              name="pymnt_mthd"
              v-model.trim="field.pymnt_mthd"
              index="value"
              label="label"
              placeholder="choose payment"
              size="sm"
              :options="paymentmethod"
            />
          </b-form-group>
          <b-form-group
            label="Transaction No."
            label-for="Transaction"
            class="mb-3"
          >
            <b-form-input
              type="text"
              size="sm"
              v-model.trim="field.tns_no"
              data-vv-name="transaction no"
              v-validate="'max:20'"
              name="tns_no"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Refunded On'"
            label-class="required"
            label-for="Refunded On"
            class="mb-3"
          >
            <DatePicker
              @change="checkdate($event, 'pymnt_date')"
              data-vv-name="refund on"
              :format="$AppDetails.organization.date_format"
              v-validate="'required'"
              input-name="created_date"
              lang="en"
              input-class="form-control"
              style="width: 100% !important"
              :not-before="this.field.date"
              name="pymnt_date"
              v-model.trim="field.pymnt_date"
              placeholder=" "
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
          </b-form-group>
          <b-form-group label="Reference No." label-for="ref_no">
            <b-form-input
              type="text"
              size="sm"
              name="ref_no"
              data-vv-name="reference no"
              v-validate="'max:30'"
              v-model.trim="field.ref_no"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row style="max-width: 1170px">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group class="mt-5 pb-2 pt-2">
            <!--  invoice extra notes -->
            <b-row>
              <b-col xl="7" lg="10" md="12" sm="12" xs="12">
                <label for="datetimepicker">Notes</label>
                <b-form-textarea
                  v-model.trim="field.pymnt_notes"
                  name="pymnt_notes"
                  :rows="4"
                  id="pymnt_notes"
                  placeholder="Notes"
                  data-vv-name="notes"
                  v-validate="'max:255'"
                />
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <div :class="{ unselectable: submitted }">
        <!-- footer block -->
        <div class="footer">
          <div
            :class="{
              'form-action': true,
              'text-left': true,
              unselectable: submitted,
            }"
          >
            <b-button
              type="submit"
              variant="primary"
              class="btn-rounded mr-3"
              :disabled="submitted"
            >
              <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i
              >Save
            </b-button>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script scoped>
// import all the components, files and funciton
import DatePicker from "vue2-datepicker"; // vue datepicker
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapGetters, mapState } from "vuex"; // to get the mapstate data of vuex
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import vSelect from "vue-select";
import $ from "jquery"; // for using jquery function

export default {
  props: ["lists","duplicatecode","message", "submitted"],
  mixins: [notificationMixin, formatDate],
  name: "Records", // page name
  components: {
    DatePicker, //datepicker
    vSelect,
  },
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      field: {
        cus_currency: "",
        unit_currency_value: "",
        is_export: "",
        cus_id: "",
        pymnt_date: "",
        tns_no: "",
        from_account: "",
        paid_amount: "",
        pymnt_mthd: "1",
        pymnt_notes: "",
        due_amount: "",
        ref_no: "",
      },

      error_show: false, // to show the error message
    };
  },
  methods: {
      redirectPage(){
         if(this.$route.query.page=='pymnt_receive'){
             this.$router.push({name:'PaymentView',params:{id:this.$route.params.id}})
              }
                if(this.$route.query.page=='cus_adv'){
             this.$router.push({name:'CustomerAdvanceView',params:{id:this.$route.params.id}})
              }
                 if(this.$route.query.page=='retainerinvoice'){
             this.$router.push({name:'RetainerInvoiceView',params:{id:this.$route.params.id}})
              }
              if(this.$route.query.page=='credit'){
             this.$router.push({name:'CreditView',params:{id:this.$route.params.id}})
              }
      },
    //To get the correct date
    checkdate(val, field) {
      this.field[field] =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },
    //  payemtn form details
    updatePayment() {
      this.field = this.lists;
    },
    //    roundoff paid amount
    roundOff() {
      this.field.paid_amount =
        typeof this.field.paid_amount != undefined &&
        !isNaN(this.field.paid_amount) &&
        this.field.paid_amount != ""
          ? parseFloat(this.field.paid_amount).toFixed(2)
          : parseFloat(0).toFixed(2);
    },
    //validation during onsubmit
    onSubmit(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // this.submitted = true;
          //   //  send the json data

          this.$emit("onSubmit", this.field);
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // show validatioj message
        }
      });
      return false;
    },
  },
  created() {
    this.initializationMessengerCode();
    this.updatePayment();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
    if (
      this.primary_acc.gl_acc_id != "" &&
      this.primary_acc.currency == this.field.cus_currency
    ) {
      this.field.from_account = this.primary_acc.gl_acc_id;
    } else {
      this.field.from_account = "46";
    }
  },

  computed: {
    ...mapGetters(["org_currency_id"]),
    // mix this into the outer object with the object spread operator
    ...mapState({
      paymentmethod: (state) => state.general.paymentmethod,
      accounts: (state) => state.general.accounts,
    }),
  },
};
</script>
